import React from "react";
import { eraLabel } from "./timelineLayout";

// The central BCE/CE era axis with ticks.
export const EraAxis = ({ ticks }) => (
  <div className="relative h-14 border-y border-[#14140f]/10 bg-[#f5f4f0]/60">
    <div className="absolute top-1/2 left-0 right-0 h-px bg-[#14140f]/20" />
    {ticks.map((t) => (
      <div key={t.y} className="absolute top-0 bottom-0 flex flex-col items-center" style={{ left: t.x }}>
        <div className="w-px h-3 bg-[#14140f]/30 mt-2.5" />
        <div className={`text-[11px] mt-1 whitespace-nowrap ${t.y === 0 ? "font-bold text-[#0a7d5f]" : "text-[#4e6073]"}`}>
          {t.y === 0 ? "1 CE" : eraLabel(t.y)}
        </div>
      </div>
    ))}
  </div>
);
